<!--
 * @Descripttion: 首页组件 - DisilShop (Almadina-inspired)
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
-->

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Banner -->
    <div class="hero" :style="{ backgroundImage: `url(${heroImage})` }">
      <div class="hero-overlay">
        <div class="hero-subtitle">FASHION IS ALL ABOUT EXPRESSING YOURSELF</div>
        <div class="hero-title">DESIGNED TO MATCH YOUR VIBE</div>
        <router-link class="hero-btn" to="/goods">SHOP NOW</router-link>
      </div>
    </div>

    <!-- Main Content -->
    <div class="home-main">
      <div class="home-container">


        <!-- Product Sections (one per matched category) -->
        <div v-for="section in homeProductSections" :key="section.id" class="am-product-section">
          <div class="am-section-title">{{ section.name }}</div>
          <ProductGrid :list="section.products" :isMore="false" :cols="3"></ProductGrid>
          <div class="am-view-all-wrap">
            <router-link class="am-view-all-btn" :to="'/goods?categoryID=' + section.id">VIEW ALL</router-link>
          </div>
        </div>

        <!-- Stats Section -->
        <div class="am-stats">
          <div class="am-stat">
            <h3>{{ totalProducts }}k</h3>
            <p>Products for Sale</p>
            <span>That's why we strive to offer a diverse range of products that cater to all tastes.</span>
          </div>
          <div class="am-stat">
            <h3>8k</h3>
            <p>Happy Customers</p>
            <span>We pride ourselves on creating great products and experiences with our valued customers.</span>
          </div>
          <div class="am-stat">
            <h3>13k</h3>
            <p>Partner Brands</p>
            <span>Partner with brands that share our values, striving to protect our environment.</span>
          </div>
        </div>

        <!-- Marquee Strip -->
        <div class="am-marquee">
          <div class="am-marquee-inner">
            <span>Exclusive Seasonal Picks</span>
            <span>Express Your True Self</span>
            <span>Curated Fashion Wonders</span>
            <span>Exclusive Seasonal Picks</span>
            <span>Express Your True Self</span>
            <span>Curated Fashion Wonders</span>
            <span>Exclusive Seasonal Picks</span>
            <span>Express Your True Self</span>
            <span>Curated Fashion Wonders</span>
          </div>
        </div>

        <!-- FAQ Section -->
        <div class="am-faq">
          <div class="am-faq-title">FREQUENTLY ASKED QUESTIONS</div>
          <div
            v-for="(item, index) in faqItems"
            :key="index"
            class="am-faq-item"
            :class="{ open: openFaq === index }"
          >
            <div class="am-faq-q" @click="toggleFaq(index)">
              <span>{{ index + 1 }}. {{ item.q }}</span>
              <i :class="openFaq === index ? 'el-icon-minus' : 'el-icon-arrow-right'"></i>
            </div>
            <div class="am-faq-a" v-show="openFaq === index">
              <p>{{ item.a }}</p>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [],
      homeCategories: [],
      homeProductSections: [],
      openFaq: -1,
      faqItems: [
        {
          q: 'What is DisilShop?',
          a: 'DisilShop is an online shopping platform offering a wide range of quality products, including fashion, home essentials, and more — all at affordable prices with reliable delivery across India.'
        },
        {
          q: 'How long does delivery take?',
          a: 'Delivery typically takes 3–5 working days in major cities and 5–7 days for remote areas. You\'ll receive tracking details once your order is shipped.'
        },
        {
          q: 'What payment methods are accepted?',
          a: 'We accept Cash on Delivery (COD), UPI, Bank Transfers, and Digital Wallets for your convenience.'
        },
        {
          q: 'Can I return or exchange a product?',
          a: 'Yes! If your product is damaged, defective, or not as described, you can request a return or exchange within 7 days of delivery. Terms and conditions apply.'
        }
      ]
    }
  },
  computed: {
    heroImage() {
      if (this.carousels && this.carousels.length) {
        return this.carousels[0].img_path
      }
      return 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769014655/68592a4DBBLOCKHANDLOOM260823G_1.avif'
    },
    totalProducts() {
      return 53
    }
  },
  activated() {
    this.load()
  },
  methods: {
    toggleFaq(index) {
      this.openFaq = this.openFaq === index ? -1 : index
    },
    load() {
      // Reset to prevent duplicates on re-activation (keep-alive)
      this.homeProductSections = []
      this.homeCategories = []

      // Load carousel / hero image
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) this.carousels = res.data
        })
        .catch(() => {})

      // Load categories + product sections
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = list

            // Define sections by matching category names (case-insensitive)
            const sectionConfigs = [
              { names: ['floral prints', 'floral'], limit: 6 },
              { names: ['digital printed', 'digital print'], limit: 6 },
              { names: ['printed comforter set', 'comforter'], limit: 6 },
              { names: ['pure cotton bedsheets', 'bedsheets', 'cotton bedsheets'], limit: 4 }
            ]

            sectionConfigs.forEach(cfg => {
              const cat = list.find(c =>
                cfg.names.some(n => c.category_name.toLowerCase().includes(n))
              )
              if (cat) {
                this.loadProductSection(cat, cfg.limit)
              }
            })
          }
        })
        .catch(err => {
          this.notifyError('Failed to load categories', err)
        })
    },
    loadProductSection(category, limit) {
      productsAPI
        .listProducts(category.category_id, 0, limit)
        .then(res => {
          if (res.status === 200) {
            const products = Array.isArray(res.data.items) ? res.data.items : []
            this.homeProductSections.push({
              id: category.category_id,
              name: category.category_name.toUpperCase(),
              products: products
            })
          }
        })
        .catch(() => {})
    },
    getCategoryImage(item) {
      // Use a default category image mapping or placeholder
      const images = {
        'floral prints': 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop6/9224419508462/img_00.jpg',
        'digital printed': 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769013639/1a9840a46099_1.avif',
        'printed comforter set': 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769015439/e857b8eFF0KIA137003_1.avif',
        'pure cotton bedsheets': 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769014655/68592a4DBBLOCKHANDLOOM260823G_1.avif'
      }
      const key = item.category_name.toLowerCase()
      return images[key] || 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769010148/magenta-printed-rayon-a-line-kurta-libas-2-430x573.jpg'
    },
    handleCatImgError(e) {
      e.target.src = 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769010148/magenta-printed-rayon-a-line-kurta-libas-2-430x573.jpg'
    }
  },
  beforeRouteEnter(to, from, next) {
    document.querySelector('body').setAttribute('style', 'background-color:#ffffff')
    next()
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector('body').setAttribute('style', 'background-color:#F5F7FA')
    next()
  }
}
</script>

<style scoped>
/* ===== Almadina-inspired Home Styles ===== */

/* Hero Banner - full width with overlay */
.hero {
  width: 100%;
  height: 70vh;
  min-height: 400px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 60%, transparent 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 8%;
}

.hero-subtitle {
  color: rgba(255,255,255,0.85);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.hero-title {
  color: #fff;
  font-size: 52px;
  font-weight: 900;
  letter-spacing: 3px;
  text-transform: uppercase;
  line-height: 1.1;
  max-width: 600px;
}

.hero-btn {
  display: inline-block;
  margin-top: 32px;
  padding: 14px 48px;
  background: #fff;
  color: #1C2B3A;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  transition: all 0.3s;
}

.hero-btn:hover {
  background: #4338CA;
  color: #fff;
}

/* Main content area */
.home-main {
  padding: 0;
}

.home-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

/* Section title */
.am-section-title {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #4338CA;
  margin: 48px 0 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Category cards - 4 column grid */
.am-categories {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.am-category-card {
  flex: 1;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s;
}

.am-category-card:hover {
  transform: translateY(-4px);
}

.am-category-card img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
}

.am-category-card h4 {
  margin-top: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #1C2B3A;
}

/* Product sections */
.am-product-section {
  margin-top: 20px;
}

.am-view-all-wrap {
  text-align: center;
  margin: 36px 0 48px;
}

.am-view-all-btn {
  display: inline-block;
  padding: 12px 48px;
  background: #4338CA;
  color: #fff !important;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  border-radius: 4px;
  transition: background 0.3s;
}

.am-view-all-btn:hover {
  background: #3730A3;
}

/* Stats band - purple background */
.am-stats {
  display: flex;
  gap: 40px;
  padding: 56px 60px;
  margin: 48px -40px;
  background: linear-gradient(135deg, #6B21A8 0%, #4338CA 100%);
}

.am-stat {
  flex: 1;
  text-align: center;
  color: #fff;
}

.am-stat h3 {
  font-size: 48px;
  font-weight: 800;
  margin: 0 0 8px;
}

.am-stat p {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px;
}

.am-stat span {
  font-size: 13px;
  opacity: 0.85;
  line-height: 1.6;
}

/* Marquee - scrolling text strip */
.am-marquee {
  margin: 48px -40px;
  padding: 16px 0;
  background: #1C2B3A;
  overflow: hidden;
}

.am-marquee-inner {
  display: flex;
  gap: 60px;
  white-space: nowrap;
  animation: marquee 25s linear infinite;
}

.am-marquee-inner span {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  flex-shrink: 0;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* FAQ section - pink/magenta background */
.am-faq {
  margin: 48px -40px;
  padding: 56px 60px;
  background: #BE185D;
}

.am-faq-title {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 32px;
  letter-spacing: 1px;
}

.am-faq-item {
  border-bottom: 1px solid rgba(255,255,255,0.2);
}

.am-faq-q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.am-faq-q i {
  font-size: 14px;
  transition: transform 0.3s;
}

.am-faq-a {
  padding: 0 0 16px;
  color: rgba(255,255,255,0.85);
  font-size: 14px;
  line-height: 1.6;
}

.am-faq-item.open .am-faq-q i {
  transform: rotate(90deg);
}


/* ===== Responsive ===== */
@media (max-width: 900px) {
  .hero-title {
    font-size: 32px;
  }

  .hero {
    height: 50vh;
  }

  .home-container {
    padding: 0 16px;
  }

  .am-categories {
    flex-wrap: wrap;
  }

  .am-category-card {
    flex: 0 0 calc(50% - 10px);
  }

  .am-stats {
    flex-direction: column;
    gap: 24px;
    padding: 40px 24px;
    margin: 32px -16px;
  }

  .am-stat h3 {
    font-size: 36px;
  }

  .am-marquee {
    margin: 32px -16px;
  }

  .am-faq {
    margin: 32px -16px;
    padding: 40px 24px;
  }


  .am-section-title {
    font-size: 22px;
    margin: 32px 0 20px;
  }
}
</style>
